import React from 'react'

import AccountFormInput from '../../components/AccountFormInput'

const PersonalInfoSection = ({ formData, handleInputChange, errors }) => (
  <>
    <h2 className="text-[19px] font-semibold text-slate-800 mb-3">
      პირადი ინფორმაცია
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <AccountFormInput
          label="სახელი"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
        />
        {errors.name && (
          <p className="text-red-500 text-xs mt-1">{errors.name}</p>
        )}
      </div>
      <div className="relative">
        <AccountFormInput
          label="ტელეფონი"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleInputChange}
          placeholder="5XX XXX XXX"
        />
        {errors.phone && (
          <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
        )}
      </div>
      <div className="relative">
        <AccountFormInput
          label="ელ.ფოსტა"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleInputChange}
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>
    </div>
  </>
)

export default PersonalInfoSection
